import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["formError"];
  static values = { max: Number };

  connect() {
    this.boundHandleSubmit = this.handleSubmit.bind(this);
    this.boundClearError = this.clearError.bind(this);
    this.element.addEventListener("submit", this.boundHandleSubmit);
    this.element.addEventListener("change", this.boundClearError);

    if (this.element.querySelector("input[data-exclusive]")) {
      this.boundHandleExclusive = this.handleExclusive.bind(this);
      this.element.addEventListener("change", this.boundHandleExclusive);
    }
  }

  disconnect() {
    this.element.removeEventListener("submit", this.boundHandleSubmit);
    this.element.removeEventListener("change", this.boundClearError);
    if (this.boundHandleExclusive) {
      this.element.removeEventListener("change", this.boundHandleExclusive);
    }
  }

  handleSubmit(event) {
    const fieldValue = event.submitter?.closest("[data-button-field-value-value]")?.dataset?.buttonFieldValueValue ?? "";
    if (fieldValue.includes("back")) return;

    const checkboxGroups = this.groupCheckboxesByName();
    const error = this.validate(checkboxGroups);

    if (error) {
      event.preventDefault();
      event.stopPropagation();
      this.formErrorTarget.textContent = error;
      this.formErrorTarget.classList.remove("hidden");
    } else {
      this.formErrorTarget.classList.add("hidden");
    }
  }

  clearError(event) {
    if (event.target.type !== "checkbox") return;
    this.formErrorTarget.classList.add("hidden");
  }

  handleExclusive(event) {
    if (event.target.type !== "checkbox" || !event.target.checked) return;
    const allCheckboxes = this.element.querySelectorAll("input[type='checkbox']");
    if (event.target.dataset.exclusive) {
      allCheckboxes.forEach((cb) => { if (cb !== event.target) cb.checked = false; });
    } else {
      allCheckboxes.forEach((cb) => { if (cb.dataset.exclusive) cb.checked = false; });
    }
  }

  groupCheckboxesByName() {
    const groups = {};
    this.element.querySelectorAll("input[type='checkbox']").forEach((checkbox) => {
      if (!this.isVisible(checkbox)) return;
      if (!groups[checkbox.name]) groups[checkbox.name] = [];
      groups[checkbox.name].push(checkbox);
    });
    return groups;
  }

  isVisible(element) {
    let el = element.parentElement;
    while (el) {
      if (getComputedStyle(el).display === "none") return false;
      el = el.parentElement;
    }
    return true;
  }

  validate(groups) {
    for (const [, checkboxes] of Object.entries(groups)) {
      const checkedCount = checkboxes.filter((cb) => cb.checked).length;

      if (checkedCount === 0) {
        return "Please select at least one option.";
      }

      if (this.hasMaxValue && checkedCount > this.maxValue) {
        return `Please select no more than ${this.maxValue} option${this.maxValue === 1 ? "" : "s"}.`;
      }
    }
    return null;
  }
}
